import { CBCore } from "cbcore-ts"
import { CALL, nil, UIButton, UIRoute, UITextView, UIView, UIViewController } from "uicore-ts"
import { RHButton } from "./Custom components/RH/RHButton"
import { RHColor } from "./Custom components/RH/RHColor"
import { RHTextField } from "./Custom components/RH/RHTextField"
import { ProcurerMainViewController } from "./ProcurerMainViewController"
import { RegisterUserViewController } from "./RegisterUserViewController"


export class LoginViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "RHR Login",
    }).addedAsSubviewToView(this.view)
    
    explanationView: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Logi sisse"
    })
    
    usernameTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Email",
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.passwordTextField.focus()
            }
        }
        
    })
    passwordTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Password",
        viewHTMLElement: {
            setAttribute: CALL("type", "password")
        },
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.loginButton.sendControlEventForKey(UIButton.controlEvent.EnterDown, nil)
            }
        }
    })
    
    loginButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Log in"
        },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    const result = await fetch("/auth/login", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            email: this.usernameTextField.text,
                            password: this.passwordTextField.text
                        })
                    })
                    
                    // @ts-ignore
                    // CBDialogViewShower.alert("Accepted: " + result["body"]["ok"])
                    
                    if (result.ok) {
                        
                        CBCore.sharedInstance.reloadSocketConnection()
                        
                        UIRoute.currentRoute
                            .routeByRemovingComponentNamed(LoginViewController.routeComponentName)
                            .routeWithViewControllerComponent(ProcurerMainViewController, {})
                            .apply()

                    }
                    
                    
                }
            }
        }
    })
    
    registerUserButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Register user"
        },
        variant: "success",
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: (sender, event) => {
                    
                    UIRoute.currentRoute.routeByRemovingComponentNamed(LoginViewController.routeComponentName)
                        .routeWithViewControllerComponent(RegisterUserViewController, nil)
                        .apply()
                    
                }
            }
        }
    })
    bottomView = new UIView().addedAsSubviewToView(this.view)
    
    constructor(view: UIView) {
        
        super(view)
        
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: RHColor.backgroundColor
        })
        
    }
    
    
    static override readonly routeComponentName = "login"
    
    static override readonly ParameterIdentifierName = {}
    
    override async viewWillAppear() {
        
        await super.viewWillAppear()
        
        if (CBCore.sharedInstance.isUserLoggedIn) {
            
            UIRoute.currentRoute.routeByRemovingComponentNamed(LoginViewController.routeComponentName)
                .routeWithViewControllerComponent(ProcurerMainViewController, nil)
                .apply()
            
        }
        
    }
    
    override async viewDidAppear() {
        
        await super.viewDidAppear()
        
        this.usernameTextField.focus()
        
        
    }
    
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        const inquiryComponent = route.componentWithName(LoginViewController.routeComponentName)
        
    }
    
    
    override updateViewConstraints() {
        
        super.updateViewConstraints()
        
    }
    
    
    override updateViewStyles() {
        
        super.updateViewStyles()
        
    }
    
    
    override viewDidLayoutSubviews() {
        
        super.viewDidLayoutSubviews()
        
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        this.explanationView.frame = this.titleLabel.frame.rectangleForNextRow(
            padding,
            [this.explanationView.intrinsicContentHeight(this.titleLabel.frame.width), padding].max()
        )
        
        
        this.usernameTextField.frame = this.explanationView.frame.rectangleForNextRow(
            padding,
            [this.usernameTextField.intrinsicContentHeight(this.explanationView.frame.width), padding].max()
        )
        this.passwordTextField.frame = this.usernameTextField.frame.rectangleForNextRow(
            padding,
            [this.passwordTextField.intrinsicContentHeight(this.usernameTextField.frame.width), padding].max()
        )
        
        this.passwordTextField.frame.rectangleForNextRow(
            padding,
            padding * 2
        ).distributeViewsEquallyAlongWidth([this.loginButton, this.registerUserButton], padding)
        this.bottomView.frame = this.loginButton.frame.rectangleForNextRow(padding, 1)
        
        
    }
}
